import { BrowserView } from 'components/DeviceDetect'
import getProductUrl from 'helpers/getProductUrl'
import React from 'react'
import { Link } from 'react-router-dom'
import useProduct from 'store/SingleProductProvider'
import { Condition, ProductConditions, ProductImage } from './Product.style'

export const CProductConditions = () => {
  const { product } = useProduct()
  return (
    <ProductConditions>
      <Condition>
        <Link to={getProductUrl(product?.slug)}>
          <img src="/img/delivery.png" alt="" />
        </Link>
        <h4>
          {product.delivery_price > 0 ? null : (
            <span className="green">: Free</span>
          )}
          Delivery
        </h4>
        <p>In Georgia</p>
      </Condition>
      {product.details?.warranty ? (
        <Condition>
          <img src="/img/guaranty.png" alt="" />
          <h4>Warranty</h4>
          <p>{product.details?.warranty} Month</p>
        </Condition>
      ) : null}
    </ProductConditions>
  )
}

const LandingProductLeftSide = () => {
  const { product } = useProduct()

  return (
    <ProductImage>
      <BrowserView>
        <CProductConditions />
      </BrowserView>

      <Link to={getProductUrl(product?.slug)}>
        <img alt="" className="product-main-pic" src={product?.image} />
      </Link>
    </ProductImage>
  )
}

export default LandingProductLeftSide
